import * as React from 'react';
import { Button } from 'antd';
import { LoadingOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { randomInt } from '../functions';
import UserContext from '../../contexts/UserContext';
import { ReactionTimeBox, MainInfoBox, FinishedBox, IState } from './ReactionTime.css';
import gamesList from '../../components/components/ChooseGame/gamesList';
import { saveUserRecord } from '../api';

function displayTime(time: number) {
    return time.toFixed(3);
}

const ReactionTime = (): JSX.Element => {
    const { useState, useContext } = React;
    const {user} = useContext(UserContext);
    const [infoText, setInfoText] = useState('Click to start');
    const [gameState, setGameState] = useState<IState>('standby');
    const [timeStart, setTimeStart] = useState(0);
    const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);
    const [finishTime, setFinishTime] = useState(-1);
    const [scoreSaved, setScoreSaved] = useState(false);

    const timerRef = React.useRef(timer);
    const setTimerRef = (tr: NodeJS.Timeout | null) => {
        timerRef.current = tr;
        setTimer(tr);
    }

    const handleChangeState = (gState?: IState) => {
        const gs = gState ? gState : gameState;
        if (gs === 'ready') {
            setGameState('standby');
            setInfoText('Failed');
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            return;
        }
        if (gs === 'standby') {
            const startTime = randomInt(400, 3600);
            console.log(startTime);
            setGameState('ready');
            setInfoText('WAIT FOR GREEN BACKGROUND');
            const tmr = setTimeout(() => {
                setGameState('good');
                setInfoText('CLICK NOW');
                setTimeStart(performance.now());
            }, startTime);
            setTimerRef(tmr);
        }
        if (gs === 'good') {
            const execTime = performance.now() - timeStart;
            setGameState('finished');
            setFinishTime(execTime);
        }
    };

    const handlePlayAgain = (restart?: boolean) => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        if (restart) {
            setTimeStart(0);
            setFinishTime(-1);
            handleChangeState('standby');
        }
    };

    const saveScore = async () => {
        const gameId = gamesList.find(x => x.id === 'rt')?.gameId || 0;
        const saved = await saveUserRecord(user.id, 0, (finishTime * 1000), gameId);
        setScoreSaved(true);
        console.log(saved);
    };

    return (
        <ReactionTimeBox state={gameState} onClick={() => handleChangeState()}>
            <MainInfoBox>
                {gameState === 'ready' && <LoadingOutlined />}
                {finishTime > 0 ? <FinishedBox>
                    <div>Your Time:</div>
                    <div>
                        <ClockCircleOutlined /> {displayTime(finishTime)}ms
                    </div>
                    <Button onClick={() => handlePlayAgain(true)}>PLAY AGAIN</Button>
                    <Button disabled={scoreSaved} onClick={saveScore}>{scoreSaved ? 'SAVED' : 'SAVE SCORE'}</Button>
                </FinishedBox> : infoText}
                {infoText === 'Failed' && <Button onClick={() => handlePlayAgain(false)}>PLAY AGAIN</Button>}
            </MainInfoBox>
        </ReactionTimeBox>
    );
};

export default ReactionTime;